import { Modal, Box } from '@mui/material';
import { ChatBox } from '@dpdgroupuk/cc-chat-fe';
import PropTypes from 'prop-types';

const ChatModal = ({
  isMinimised,
  onClose,
  onMinimize,
  chatConfig,
  parcelCode,
  collectionReference,
  collectionPostcode,
}) => (
  <Modal
    open={!isMinimised}
    onClose={onMinimize}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      px: 2,
      visibility: isMinimised ? 'hidden' : 'visible',
      'pointer-events': isMinimised ? 'none' : 'auto',
    }}
    keepMounted
    data-testid='chat-modal'
  >
    <Box sx={{ width: '650px', maxWidth: '100%' }}>
      <ChatBox
        initialConfig={chatConfig}
        onClose={onClose}
        onMinimize={onMinimize}
        customizations={{ hideEmailByAdvisorsBusy: true }}
        ratingEnabled={false}
        parcelCode={parcelCode || null}
        collectionReference={collectionReference || null}
        collectionPostcode={collectionPostcode || null}
      />
    </Box>
  </Modal>
);

ChatModal.propTypes = {
  isMinimised: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
  chatConfig: PropTypes.object.isRequired,
  parcelCode: PropTypes.string,
  collectionReference: PropTypes.string,
  collectionPostcode: PropTypes.string,
};

export default ChatModal;
